import React, {useEffect, useState} from "react";
import statusService from "../../../services/statusService.js";

const Statuses = ({handleStatusesOptionClick, selectedStatus}) => {

    const [dataStatuses, setDataStatus] = useState({});
    const [isOpen, setIsOpen] = useState(false);

    const loadStatuses = () => {
        statusService.getStatuses().then(statuses => {
            if (statuses.success) {
                setDataStatus(statuses.data);
            }
        });
    };

    const handleOptionClick = (status) => {
        handleStatusesOptionClick(status);
        setIsOpen(false);
    }

    const toggleDropdown = () => setIsOpen(!isOpen);

    useEffect( () => {
        loadStatuses();
    }, []);

    return (
        <div className="task-select">
            <div className="custom-select over-layout">
                <div
                    className="select-header"
                    onClick={toggleDropdown}
                    style={{
                        backgroundColor: selectedStatus?.color || '#f0f0f0',
                        color: selectedStatus?.color ? '#fff' : '#000',
                    }}
                >
                    {selectedStatus?.name || 'Pendiente de aprobación'}
                </div>
                {isOpen && (
                    <ul className="select-options">
                        {Array.isArray(dataStatuses) &&
                            dataStatuses.map((status) => (
                                <li
                                    key={status.id}
                                    onClick={() => handleOptionClick(status)}
                                    style={{
                                        backgroundColor: status.color,
                                        color: '#fff',
                                    }}>
                                    {status.name}
                                </li>
                            ))}
                    </ul>
                )}
            </div>
        </div>
    );

}

export default Statuses;